/**
 * @format
 */
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CourseUnit, CourseUnitRealisation, EnrolmentCalculationConfig } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { AppErrorHandler, ContentSwitchTab, EnrolmentCalculationConfigEntityService } from 'sis-components';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'app-course-unit-realisation-info',
    templateUrl: './course-unit-realisation-info.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitRealisationInfoComponent implements OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.courseUnitInfoModal.courseUnitRealisation.courseUnitRealisationInfo',
        directiveName: 'appCourseUnitRealisationInfo',
    };

    @Input() courseUnitRealisation: CourseUnitRealisation;
    @Input() courseUnit: CourseUnit;
    @Input() level = 4;
    @Input() currentTabIndex = 0;

    tabs: ContentSwitchTab[] = [
        { title: 'SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.TAB_HEADINGS.BASIC_INFO' },
        { title: 'SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.TAB_HEADINGS.ENROLMENT_INFO' },
        { title: 'SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.TAB_HEADINGS.STUDY_GROUPS' },
    ];

    enrolmentCalculationConfig$: Observable<EnrolmentCalculationConfig>;

    constructor(
        private readonly enrolmentCalculationConfigService: EnrolmentCalculationConfigEntityService,
        private readonly appErrorHandler: AppErrorHandler,
    ) {}

    ngOnInit() {
        this.enrolmentCalculationConfig$ = this.enrolmentCalculationConfigService
            .getEnrolmentCalculationConfigOrNull(this.courseUnitRealisation.id)
            .pipe(this.appErrorHandler.defaultErrorHandler());
    }
}
